export default __webpack_public_path__ + "c88863217bb780c1a38fcf01b8191f22.png";